import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_layout/data-deletion/')({
    component: DataDeletionPage,
});
function DataDeletionPage() {
    return (<div className="mx-auto max-w-3xl px-4 py-16 space-y-6">
            <h1 className="text-3xl font-semibold">Facebook Data Deletion Instructions</h1>

            <p className="text-muted-foreground">
                Adora respects your privacy and gives you full control over your data.
            </p>

            <section className="space-y-2">
                <h2 className="text-xl font-medium">What data we store</h2>
                <ul className="list-disc pl-6 text-sm text-muted-foreground">
                    <li>Facebook account ID</li>
                    <li>Email address</li>
                    <li>Name</li>
                </ul>
            </section>

            <section className="space-y-2">
                <h2 className="text-xl font-medium">How to request deletion</h2>
                <p className="text-sm text-muted-foreground">To request deletion of your data:</p>
                <ol className="list-decimal pl-6 text-sm text-muted-foreground">
                    <li>
                        Email <strong>thovandeth@gmail.com</strong>
                    </li>
                    <li>
                        Subject: <strong>Facebook Data Deletion Request On Adora</strong>
                    </li>
                    <li>Include your Adora account email</li>
                </ol>
            </section>

            <p className="text-xs text-muted-foreground">Requests are processed within 30 days.</p>
        </div>);
}
